var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.328 2.222 L 15.328 16.444 L 19.868 16.444 L 19.868 2.222 L 15.328 2.222 Z M 16.237 3.238 L 18.96 3.238 L 18.96 5.27 L 16.237 5.27 L 16.237 3.238 Z M 16.237 6.286 L 18.96 6.286 L 18.96 15.428 L 16.237 15.428 L 16.237 6.286 Z",
    style: {
      fill: "rgb(34, 34, 34)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.155 4.998 L 0.155 14.52 L 4.405 14.52 L 4.405 15.472 L 2.705 15.472 L 2.705 16.424 L 9.506 16.424 L 9.506 15.472 L 7.805 15.472 L 7.805 14.52 L 12.055 14.52 L 12.055 4.998 L 0.155 4.998 Z M 1.005 5.95 L 11.206 5.95 L 11.206 13.568 L 1.005 13.568 L 1.005 5.95 Z M 5.255 14.52 L 6.956 14.52 L 6.956 15.472 L 5.255 15.472 L 5.255 14.52 Z",
    style: {
      fill: "rgb(34, 34, 34)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComputer);
export default __webpack_public_path__ + "static/media/ico-computer.791b48cf3cf6df4648eb4c995757df13.svg";
export { ForwardRef as ReactComponent };